import Glide from "@glidejs/glide";

/**
 * @module GlideInitializer
 *
 */
export default class GlideInitializer {
    constructor() {
        this.tdCarouselReady();
    }

    /**
     * @method init
     * @returns {undefined}
     */
    init(dom) {
        const configuration = this.buildConfiguration(dom.dataset.configuration);
        const toggleButton = dom.querySelector('.js-autoplay-toggle')
        const slides = dom.querySelectorAll('.glide__slide');

        if (slides.length > 0) {
            const glide = new Glide(dom, configuration);
            this.setRealTimeEvents(glide, slides);

            if (slides.length > 1 && configuration?.autoplay) {
                glide.on('mount.before', () => {
                    dom.dispatchEvent(new CustomEvent("beforeGlideMount", {detail: glide}));
                    this.setupIntersectionObserver(glide, dom, toggleButton);
                    this.setupAutoplayControl(glide, toggleButton);
                });
            }

            glide.mount();
            if (document.readyState !== 'complete') {
                document.addEventListener('readystatechange', () => {
                    if (document.readyState === 'complete') {
                        glide.update();
                    }
                });
            }

            const thumbnails = dom.querySelectorAll('[data-glide-scroll]');
            thumbnails.forEach((thumbnail) => {
                thumbnail.addEventListener('click', () => {
                    this.scrollToSliderTopWithOffset(dom);
                })
            });
        }
    };

    scrollToSliderTopWithOffset(element) {
        if (element.getBoundingClientRect().top < 0) {
            const headerHeight = document.querySelector('.header').offsetHeight;
            const yPosition = element.getBoundingClientRect().top + window.pageYOffset;
            const elementPosition = yPosition - headerHeight;

            window.scrollTo({
                top: elementPosition,
                behavior: 'smooth'
            });
        }
    }

    /**
     * @param configuration
     * @return {JSON}
     */
    buildConfiguration(configuration) {
        const givenConfig = JSON.parse(configuration);
        let glideConfiguration = {};
        const breakpointsConfiguration = {};

        if (givenConfig.hasOwnProperty("default")) {
            glideConfiguration = givenConfig.default;
        }

        if (givenConfig.hasOwnProperty("tabletSize") && givenConfig.hasOwnProperty("tablet")) {
            breakpointsConfiguration[givenConfig.tabletSize] = givenConfig.tablet;
        }

        if (givenConfig.hasOwnProperty("phoneSize") && givenConfig.hasOwnProperty("phone")) {
            breakpointsConfiguration[givenConfig.phoneSize] = givenConfig.phone;
        }

        glideConfiguration["breakpoints"] = breakpointsConfiguration;

        return glideConfiguration;
    };

    /**
     * Disable sliding, if not enough slides are available
     * @param glide
     * @param slides
     */
    setRealTimeEvents(glide, slides) {
        glide.on("mount.after", function () {
            if (slides.length <= glide._o.perView) {
                glide.disable();
            }
        });

        glide.on("resize", function () {

            if (slides.length <= glide._o.perView) {
                if (glide.index !== 0) {
                    glide.go("=0");
                }
                glide.disable();
            } else {
                glide.enable();
            }
        });
    };

    tdCarouselReady() {
        if (document.readyState !== "loading") {
            this.tdCarouselLoader();
        } else {
            document.addEventListener("DOMContentLoaded", () => {
                this.tdCarouselLoader()
            });
        }
    }


    tdCarouselLoader() {
        const carousels = document.querySelectorAll(".glide");
        if (carousels.length > 0) {
            for (let i = 0; i < carousels.length; ++i) {
                const currentCarousel = carousels[i];
                const slides = currentCarousel.querySelectorAll(".glide__slide");

                // Instantiating a Class only when the carousel has slide(s)
                if (slides.length > 0) {
                    this.init(currentCarousel);
                }
            }
        }
    }

    /**
     * Intersection Observer
     * @param glide
     */
    0
    setupIntersectionObserver = function (glide, dom, toggleButton) {
        var observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        glide.play();
                        toggleButton.classList.remove('pause');
                    } else {
                        glide.pause();
                        toggleButton.classList.add('pause');
                    }
                });
            },
            {
                root: null,
                rootMargin: "20px",
                threshold: 0.8,
            });
        observer.observe(dom);
    };

    /**
     * Autoplay control
     * @param glide
     */
    setupAutoplayControl = function (glide, toggleButton) {
        toggleButton.addEventListener('click', () => {
            if (!toggleButton.classList.contains('pause')) {
                glide.pause();
                toggleButton.classList.add('pause');
            } else {
                glide.play();
                toggleButton.classList.remove('pause');
            }
        });
    };

}
